var lis = document.getElementById("reviews-list").getElementsByTagName("li");
[...lis].forEach(function (li, index) {
    li.style.setProperty("--height", calculateHeight(lis, index));
});

window.addEventListener("scroll", handleViewChange);

function handleViewChange(){
    [...lis].forEach(function (li, index) {
        if(isElementInViewport(li)){
            li.classList.add('in-view');
            if(index + 1 < lis.length){
                lis[index].classList.add('cookie-marker')
            }
        } else{
            li.classList.remove('in-view');
            li.classList.remove('cookie-marker');
        }
    });
}

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

function calculateHeight(lis, curIndex) {
    let currentLi = lis[curIndex];
    let nextLi = false;

    let height = 0;
    let nextIndex = curIndex + 1;


    if(window.innerWidth >= 1024){
        if (nextIndex < lis.length) {
            nextLi = lis[nextIndex];
            height = nextLi.offsetHeight * .5 + currentLi.offsetHeight * .5;

            //even (lefthand side) li
            if( curIndex !== 0 && !(curIndex & 1) ){
                height = height -  nextLi.offsetHeight * .5 - 60;
            }
        }
    } else{
        // Logic for mobile lines
        if (curIndex == 0) {
            nextLi = lis[nextIndex];
            height = nextLi.offsetHeight * 1 + currentLi.offsetHeight * 1 + 50;
        }
        else if (nextIndex < lis.length) {
            nextLi = lis[nextIndex];
            height = nextLi.offsetHeight * .5 + currentLi.offsetHeight * .5 + 50;
        }

    }
    return height + "px";
}

